module.exports = __webpack_public_path__ + "static/media/confort.a08ca560.svg";